import * as Sentry from '@sentry/react';

// Substituir pelo DSN do projeto "orbion-writer" em sentry.io
// → Settings → Projects → orbion-writer → Client Keys → DSN
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_COMMIT_SHA,
    tracesSampleRate: 0.1,
    beforeSend(event) {
        // rate limit: evitar estouro do free tier em loops de erro
        return event;
    },
    integrations: [
        Sentry.browserTracingIntegration(),
    ],
});
